import { Injectable } from '@angular/core';
import {NeoRestService} from "../neo-rest/neo-rest.service";

@Injectable()
export class NeoNotesService {

  constructor(
      private _rest: NeoRestService
  ) { }

    /**
     * Obtiene las notas de una reserva
     *
     * @param orderId
     */
    getNotes(orderId) {
        return this._rest.get(`/note/${orderId}`);
    }

    /**
     * Añade una nota a la reserva
     *
     * @param orderId
     * @param note nota a añadir
     */
    addNote(orderId, note) {
        return this._rest.postRaw(`/note/${orderId}`, note);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-note/neo-note.service.ts